import { render, staticRenderFns } from "./AddSubForm.vue?vue&type=template&id=8c989a26&scoped=true&lang=pug&"
import script from "./AddSubForm.vue?vue&type=script&lang=js&"
export * from "./AddSubForm.vue?vue&type=script&lang=js&"
import style0 from "./AddSubForm.vue?vue&type=style&index=0&id=8c989a26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c989a26",
  null
  
)

export default component.exports